import React from 'react';
import { PRODUCT_TYPES } from '../../../constants';
import { useLanguage } from '../../../i18n/LanguageContext';

const ProductTableHeader = React.memo(({
  activeTypeTab,
  filteredProductsCount,
  isAdmin,
  isSatisci,
  isMontajci,
  isExcelLoading,
  fileInputRef,
  handleImportExcel,
  handleImportClick,
  handleExportExcel,
  handleClearList
}) => {
  const { t } = useLanguage();
  const currentTypeLabel = t(`productTypes.${activeTypeTab}`, PRODUCT_TYPES[activeTypeTab]?.label || activeTypeTab);

  return (
    <div className="product-table-header-bar">
      <div className="product-table-title">
        <i className="fas fa-list"></i>
        <span>{currentTypeLabel}</span>
        <span className="product-count">({filteredProductsCount} {t('productList.excel.productUnit', 'ürün')})</span>
      </div>
      {(isAdmin || isSatisci) && !isMontajci && (
        <div className="excel-actions">
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: 'none' }}
            accept=".xlsx, .xls, .csv"
            onChange={handleImportExcel}
          />
          <button
            className="btn-excel btn-import"
            onClick={handleImportClick}
            disabled={isExcelLoading}
          >
            {isExcelLoading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-file-import"></i>} {t('productList.excel.import', "Excel'den Yükle")}
          </button>
          <button
            className="btn-excel btn-export"
            onClick={handleExportExcel}
            disabled={filteredProductsCount === 0 || isExcelLoading}
          >
            <i className="fas fa-file-export"></i> {t('productList.excel.export', "Excel'e Aktar")}
          </button>
          <button
            className="btn-excel btn-clear-list"
            onClick={handleClearList}
            disabled={isExcelLoading}
            title={t('productList.excel.clearList', 'Listeyi Temizle')}
          >
            <i className="fas fa-trash-alt"></i> {t('productList.excel.clearList', 'Listeyi Temizle')}
          </button>
        </div>
      )}
    </div>
  );
});

export default ProductTableHeader;
